/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import WebhookConfig from '../model/WebhookConfig';

/**
* Webhook service.
* @module api/WebhookApi
* @version 1.0.0
*/
export default class WebhookApi {

    /**
    * Constructs a new WebhookApi. 
    * @alias module:api/WebhookApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getWebhookConfig operation.
     * @callback module:api/WebhookApi~getWebhookConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WebhookConfig} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Current webhook delivery configuration; the secret is only reported as set or unset
     * @param {module:api/WebhookApi~getWebhookConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WebhookConfig}
     */
    getWebhookConfig(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = WebhookConfig;
      return this.apiClient.callApi(
        '/webhook/config', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateWebhookConfig operation.
     * @callback module:api/WebhookApi~updateWebhookConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WebhookConfig} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replace the webhook delivery configuration
     * @param {module:model/WebhookConfig} webhookConfig 
     * @param {module:api/WebhookApi~updateWebhookConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WebhookConfig}
     */
    updateWebhookConfig(webhookConfig, callback) {
      let postBody = webhookConfig;
      // verify the required parameter 'webhookConfig' is set
      if (webhookConfig === undefined || webhookConfig === null) {
        throw new Error("Missing the required parameter 'webhookConfig' when calling updateWebhookConfig");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = WebhookConfig;
      return this.apiClient.callApi(
        '/webhook/config', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
